__turbopack_context__.v({
  "breadcrumb": "ArticlePageHeader-module__MXEsEW__breadcrumb",
  "byline": "ArticlePageHeader-module__MXEsEW__byline",
  "header": "ArticlePageHeader-module__MXEsEW__header" + " " + __turbopack_context__.i(41529)["header"],
  "headerContent": "ArticlePageHeader-module__MXEsEW__headerContent" + " " + __turbopack_context__.i(41529)["headerContent"],
  "prefix": "ArticlePageHeader-module__MXEsEW__prefix",
  "status": "ArticlePageHeader-module__MXEsEW__status",
});
